<template>
  <div class="block-video d-flex flex-column py-12">
    <bim-text class="block-video__title mb-12" type="h4" bold>Видео о работе сервиса</bim-text>
    <vue-plyr class="lazy-load-on mx-auto block-video__video-wrapper">
      <div data-plyr-provider="youtube" data-plyr-embed-id="hGO15gP5w1Y"></div>
    </vue-plyr>
  </div>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import VuePlyr from "@/components/VuePlyrPlugin/index"
export default {
  name: "BlockVideo",
  components: {
    bimRow,
    bimCol,

    VuePlyr
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.block-video {
  width: 100%;
  position: relative;
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $white-color-100;
    z-index: -1;
  }

  .block-video__title {
    text-align: center;
  }

  .block-video__video-wrapper {
    max-width: 679px;
    width: 100%;
  }
}
</style>
